module.exports = __webpack_public_path__ + "img/wendy-fung_thumbnail.70dec0dd.jpg";